module.exports = __webpack_public_path__ + "i18n/es_64f66061ce47df4aaf0710979a45fa63.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/es.json
// module id = +lAx
// module chunks = 154